import React from 'react';
import i18next from 'i18next';
import moment from 'moment-timezone';
import { Map, TileLayer } from 'react-leaflet';
import L from 'leaflet';

import { PageTitle } from '../PageTitle';
import { GroupingsService } from '../../services';
import { Modal } from 'react-bootstrap';

import config from "config";

class GroupingView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      grouping: null,
      deviceGroupingId: props.match.params.deviceGroupingId,
      errorMessage: null
    };
  }

  componentDidMount() {
    GroupingsService.get(this.state.deviceGroupingId, true).then((response) => {
      this.setState({ grouping: response.grouping });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-group') });
      console.log(error);
    });
  }

  render() {
    if (this.state.grouping) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <GroupingDetail
            grouping={this.state.grouping}
            backLinkSearch={backLinkSearch}
          />
      );
    } else {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }
}

class GroupingDetail extends React.Component {
  constructor(props) {
    super(props);
    let ROOT = GroupingsService.getRoot();
    let imgString = ""
    for (let i = 0; i < this.props.grouping.metadata.length; i++) {
      let element = this.props.grouping.metadata[i]
      if (element.deviceGroupingMetadataType.token == "img") {
        imgString = element.stringValue
      }
    }
    this.state = {
      loadedImage: null,
      showImageModal: false,
      imageSource: `${ROOT}groupings/images/${imgString}`
    }

    this.toggleShowImageModal = this.toggleShowImageModal.bind(this);
  }
  onLoad(item) {
    this.setState(({ loadedImage }) => {
      return { loadedImage:  item}
    })
  }

  openImage() {
    this.toggleShowImageModal()
  }

  toggleShowImageModal() {
    this.setState({
      showImageModal: !this.state.showImageModal
    });
  }

  showMetadata() {
    let show = false
    if (this.props.grouping.metadata.length <= 0) {
      return false
    } else {
      for (let i = 0; i < this.props.grouping.metadata.length; i++) {
        let element = this.props.grouping.metadata[i]
        if (element.deviceGroupingMetadataType.token != "geo_bounds" &&
          element.deviceGroupingMetadataType.token != "geo_lat" &&
        element.deviceGroupingMetadataType.token != "geo_lon") {
          if (element.deviceGroupingMetadataType.token == "img") {
            show = this.state.loadedImage
          } else {
            return true
          }
        }
      }
    }
    return show
  }

  showMap(lat, long) {
    if (lat && long)
      return true
    if (this.props.grouping.metadata.length <= 0) {
      return false
    } else {
      for (let i = 0; i < this.props.grouping.metadata.length; i++) {
        let element = this.props.grouping.metadata[i]
        if (element.deviceGroupingMetadataType.token == "geo_bounds")
          return true
      }
    }
    return false
  }

  render() {
    let abbr = moment.tz(this.props.grouping.timezone).zoneAbbr();
    let fullZone = `${this.props.grouping.timezone} (${abbr})`;

    let lat = ""
    let long = ""
    if (this.props.grouping.metadata) {
      for (let i = 0; i < this.props.grouping.metadata.length; i++) {
        let cur = this.props.grouping.metadata[i]
        if (cur.deviceGroupingMetadataType.token == "geo_lat") {
          lat = cur.stringValue
        } else if (cur.deviceGroupingMetadataType.token == "geo_lon") {
          long = cur.stringValue
        }
      }
    }

    return (
        <div className="grouping-view groupings">
          <div className="row">
            <PageTitle title={this.props.grouping.name}
                       editLinkWithParams={{
                         link: {
                           pathname: `/admin/groupings/edit/${this.props.grouping.id}`,
                           uiroute: '/admin/groupings/edit/:deviceGroupingId',
                           state: {
                             backLinkSearch: this.props.backLinkSearch
                           }
                         }
                       }}
                       backLinkWithParams={{
                         link: {
                           pathname: '/admin/groupings',
                           search: this.props.backLinkSearch
                         }
                       }} />
          </div>
          <div className="op-content-box devices">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-4 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-business-structure">
                  <label>{i18next.t('form-labels.business-structure')}:</label><p>{this.props.grouping.deviceGroup == null ? this.props.grouping.enterprise.name : this.props.grouping.deviceGroup.name}</p>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-group-parent">
                  <label>{i18next.t('pages.groups.parent-group')}:</label><p>{this.props.grouping.parent == null ? 'None' : this.props.grouping.parent.name}</p>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-group-child">
                  <label>{i18next.t('pages.groups.sub-group-count')}:</label><p>{this.props.grouping.children.length}</p>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-group-child">
                  <label>{i18next.t('pages.groups.alerts-paused')}</label><p>
                  {!this.props.grouping.actionsEnabled ? i18next.t('yes') : i18next.t('no')}
                </p>
                </div>
              </div>
              {this.props.grouping.deviceGroup.requiresTimezone &&
              <div className="col-sm-12 col-md-6 col-lg-4 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-group-child">
                  <label>{i18next.t('timezone')}</label><p>
                  {fullZone}
                </p>
                </div>
              </div>
              }
            </div>
            {this.showMetadata() ?
            <div className='op-content-box-level-2'>
                          <div className="row">
              <div className="col-sm-12">
                <ul className="list-inline clearfix remove-margin-bottom actions-header">
                  <li className="pull-left"><h4 className="remove-margin-bottom">{i18next.t('pages.groups.grouping-metadata')}</h4></li>
                </ul>
              </div>
                <div className="col-sm-12 oc-mini-card">
                  <div className="inner">
                    <div className="row">
                      {
                        this.props.grouping.metadata.map((element, index) => element.deviceGroupingMetadataType.token != "img" ?
                        (element.deviceGroupingMetadataType.token != "geo_bounds" && element.deviceGroupingMetadataType.token != "geo_lat" && element.deviceGroupingMetadataType.token != "geo_lon") ?
                          <div className="form-group col-sm-12 col-lg-6" key = {index}>
                            <label>{i18next.t(`device-grouping-metadata-types.${element.deviceGroupingMetadataType.token}`)}: {element.stringValue} </label>

                            </div> :
                            null
                            :
                            <div className="col-sm-4" key = {index}>
                              <div className="panel-heading">
                                {i18next.t(`device-grouping-metadata-types.${element.deviceGroupingMetadataType.token}`)}
                              </div>
                              <div className="metadata-inner">
                                { this.state.loadedImage ?
                                  <div className="device-image-container group-image">
                                     <div onClick={this.openImage.bind(this)} className="device-image-in-situ"  style={{position: 'relative', backgroundImage: `url(${this.state.imageSource})`, height: 125, backgroundSize: 'cover'}}>
                                      <img className='device-image-zoom' src={`${config.WEB_BASE_URL}/images/icon/enlarge.svg`} />
                                    </div>
                                  </div>
                                    :
                                    <div className="no-image-found-box"><img src={`${config.WEB_BASE_URL}/images/icon/no_image_icon.svg` }/><em>{i18next.t('no-image-found')}</em></div>
                                }
                              </div>
                            </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
                : null
            }
            {
              this.showMap(lat, long) ?
              <MapModal boundsData={this.props.grouping.metadata} lat = {lat} long = {long}/>
            : null
          }
          </div>
          <div className="hidden">
            {/* this mechanism toggles the render of the device image section, above - there may be a tidier way to do this */}
            <img
                src={this.state.imageSource}
                onLoad={this.onLoad.bind(this, this.state.imageSource)}/>
          </div>

          <Modal dialogClassName="devices" show={this.state.showImageModal} onHide={this.toggleShowImageModal}>
            <Modal.Header closeButton>
              <Modal.Title>{i18next.t('image')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <img src={this.state.imageSource} alt={i18next.t('image')} />
              </div>
            </Modal.Body>
          </Modal>
        </div>
    );
  }
}

class MapModal extends React.Component {
  update(bounds, markerBounds) {
    if (markerBounds[0] > bounds[0][0] && markerBounds[0] > bounds[1][0]) {
      bounds[1][0] = markerBounds[0]
    }
    else if (markerBounds[0] < bounds[0][0] && markerBounds[0] < bounds[1][0]) {
      bounds[0][0] = markerBounds[0]
    }
    if (markerBounds[1] > bounds[0][1] && markerBounds[1] > bounds[1][1]) {
      bounds[1][1] = markerBounds[1]
    }
    else if (markerBounds[1] < bounds[0][1] && markerBounds[1] < bounds[1][1]) {
      bounds[0][1] = markerBounds[1]
    }
    return bounds
  }

  render() {
    var _editableFG = null;
    var mapBounds = null;
    var points = this.props.boundsData;
    var layer = null;
    var map = null;

    var _onFeatureGroupReady = (reactFGref) => {
      let leafletFG = reactFGref;
      this._editableFG = reactFGref;
    }

    const myCustomColour = '#ff0000'

    const markerHtmlStyles = `
      background-color: ${myCustomColour};
      width: 3rem;
      height: 3rem;
      display: block;
      left: -1.5rem;
      top: -1.5rem;
      position: relative;
      border-radius: 3rem 3rem 0;
      transform: rotate(45deg);
      border: 1px solid #FFFFFF`

    const icon = L.divIcon({
      className: "my-custom-pin",
      iconAnchor: [0, 24],
      labelAnchor: [-6, 0],
      popupAnchor: [0, -36],
      html: `<span style="${markerHtmlStyles}" />`
    })


    var handleLeafletLoad = (event) => {
      var currBounds = document.getElementsByClassName("current-bounds")
      if (currBounds.length == 0) {
        let fgVar = this._editableFG;
        this.mapBounds = findGroupingBounds(this.props.boundsData);
        let boundFit =  findGroupingBounds(this.props.boundsData)
        var map = event.target._map;
        map.on(L.Draw.Event.CREATED, function (e) {
           var type = e.layerType,
               layer = e.layer;
           if (type === 'marker') {
             if (this.lastMarker) {
               map.removeLayer(this.lastMarker);
             }
             this.lastMarker = e.layer
           }
           if (type === 'rectangle') {
             if (this.lastRect) {
               map.removeLayer(this.lastRect);
             }
             this.lastRect = e.layer
           }
        });
        if (this.props.lat && this.props.long) {
          this.markerBounds = [this.props.lat, this.props.long]
          let markerRect = L.marker(this.markerBounds, {icon: icon}).addTo(map);
          if (boundFit[0])
            boundFit = this.update(boundFit,this.markerBounds)
        }
        if(this.mapBounds[0]) {
          let boundRect = L.rectangle(this.mapBounds, {stroke: "#bb1111", strokeOpacity: 0.5, strokeWidth: 4, color: "#ff4444", weight: 1, fillOpacity: 0.2, className: "current-bounds"}).addTo(map);
        }
        if (boundFit[0]) {
          map.fitBounds(boundFit);
        }
      }
    }

    var findGroupingBounds = (groupingMetadata) => {
      let groupingBounds = [];

      const geoboundsMetadata = groupingMetadata.filter(md => md.deviceGroupingMetadataType.token === 'geo_bounds');
      if (geoboundsMetadata && geoboundsMetadata.length > 0) {
          const latLngPairs = geoboundsMetadata[0].stringValue.split(';');

          latLngPairs.forEach(llp => {
              const ll = llp.split(',');
              groupingBounds.push([parseFloat(ll[0]), parseFloat(ll[1])]);
          });

          if (groupingBounds.length > 2) {
              groupingBounds = [ groupingBounds[0], groupingBounds[2] ];
          }
      }

      return groupingBounds;
    }

    return (
        <Map id="mapId" center={[33.222,-96.222]} zoom={10}>
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
            onLoad={handleLeafletLoad}
          />
        </Map>
    );
  }
}

export default GroupingView;
